import { Link } from "react-router-dom"
import BlogPostCard from "./BlogPostCard"
import { ArrowRight, FileText } from "lucide-react"

/** Renders featured posts. Accepts `posts` from parent (e.g. from public API). */
export default function FeaturedPosts({
  posts = [],
  space,
  limit = 3,
  showViewAll = true,
  blogPath: blogPathProp,
  showSectionTitle = true,
  sectionTitle = "Articles récents",
  emptyMessage = "Aucun article pour le moment.",
  className = ""
}) {
  const featuredPosts = Array.isArray(posts) ? posts.slice(0, limit) : []
  const blogPath = blogPathProp ?? (space ? `/etudiants/blog/${space}` : "/actualites")

  return (
    <div className={className}>
      {(showSectionTitle || showViewAll) && (
        <div className={`flex flex-wrap items-center gap-4 mb-6 ${showSectionTitle ? "justify-between" : "justify-end"}`}>
          {showSectionTitle && (
            <h2 className="text-2xl font-bold text-foreground">{sectionTitle}</h2>
          )}
          {showViewAll && (
            <Link
              to={blogPath}
              className="inline-flex items-center gap-2 text-sm font-semibold text-primary hover:gap-3 transition-all group"
            >
              Voir tous les articles
              <ArrowRight className="w-4 h-4 group-hover:translate-x-1 transition-transform" />
            </Link>
          )}
        </div>
      )}

      {featuredPosts.length > 0 ? (
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {featuredPosts.map((post) => (
            <BlogPostCard key={post._id} post={post} space={space} />
          ))}
        </div>
      ) : (
        <div className="rounded-2xl border border-dashed border-border bg-muted/30 py-12 px-6 text-center">
          <FileText className="w-12 h-12 text-muted-foreground/50 mx-auto mb-3" />
          <p className="text-sm text-muted-foreground mb-4">{emptyMessage}</p>
          {showViewAll && (
            <Link
              to={blogPath}
              className="inline-flex items-center gap-2 text-sm font-semibold text-primary hover:gap-3 transition-all group"
            >
              Voir le blog
              <ArrowRight className="w-4 h-4 group-hover:translate-x-1 transition-transform" />
            </Link>
          )}
        </div>
      )}
    </div>
  )
}
